import React from 'react';
import { motion } from 'framer-motion';

const SecretFormula = () => {
  return (
    <section className="relative py-16 px-4 bg-white overflow-hidden">
      <div className="max-w-3xl mx-auto relative z-10">
        <motion.h2 
          className="text-4xl font-bold text-gray-900 text-center mb-8"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          The Simple "Secret" Formula to Landing a High-Paying Cloud Job
        </motion.h2>

        <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-8 shadow-lg border border-gray-100">
          <div className="space-y-6 text-gray-700">
            <p>
              Through years of experience in cloud engineering and teaching others, we've discovered that success in cloud engineering comes down to mastering three core principles:
            </p>

            <div className="space-y-4">
              <div className="flex items-start space-x-4">
                <span className="text-2xl">🛠️</span>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-1">
                    Master the Core Technical Skills
                  </h3>
                  <p>
                    Learn essential cloud services, Infrastructure as Code, and DevOps practices through hands-on projects and real-world scenarios.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <span className="text-2xl">🔄</span>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-1">
                    Build Automation Expertise
                  </h3>
                  <p>
                    Develop skills in creating efficient workflows, CI/CD pipelines, and infrastructure automation that companies desperately need.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <span className="text-2xl">🎯</span>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-1">
                    Apply Best Practices & Security
                  </h3>
                  <p>
                    Learn industry best practices for cloud architecture, security, and cost optimization that make you invaluable to employers.
                  </p>
                </div>
              </div>
            </div>

            <p className="mt-8">
              When you implement these principles correctly, transitioning into a cloud engineering role becomes a predictable, repeatable process rather than a game of chance.
            </p>

            <motion.button
              className="w-full bg-[#0EA5E9] text-white font-medium py-4 px-8 rounded-xl hover:bg-[#0284C7] transition-colors mt-6"
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              onClick={() => {
                const pricingSection = document.querySelector('#pricing-section');
                if (pricingSection) {
                  pricingSection.scrollIntoView({ behavior: 'smooth' });
                }
              }}
            >
              Learn Our Proven Method
            </motion.button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SecretFormula; 